import React from 'react';

import LinkCopy from '@components/LinkCopy';
import SectionBreakTitle, { SectionColor } from '@components/SectionBreakTitle';
import Spinner from '@components/Spinner';
import { useCurrentUser } from '@hooks';
import { PLAN_TYPE_MONTHLY } from '@src/constants';

import styles from './styles.module.css';

const Affiliate = () => {
  const { currentUser, isLoadingCurrentUser } = useCurrentUser();

  return (
    <>
      {isLoadingCurrentUser ? (
        <Spinner />
      ) : (
        <>
          <SectionBreakTitle
            className="mb-32"
            titleClassName="text-primary-magenta"
            color={SectionColor.Magenta}
            title="Referral program"
          />
          {currentUser?.settings_access_obj?.referral_access &&
          currentUser.subscription?.plan_type != PLAN_TYPE_MONTHLY ? (
            <div>
              <div className={styles.referralHeader}>
                As a benefit of your subscription, you can give 25% off access to The Information.
              </div>
              <div className={styles.affiliateLinkContainer}>
                <div className={styles.affiliateLinkContent}>
                  <div className={styles.affiliateTiShareDesc}>
                    <p>Your custom invite link</p>
                  </div>
                  <LinkCopy
                    clipboardLink={currentUser.referral_url}
                    trackingProps={{
                      'data-link': 'Settings Affiliate Referral Link - Click on Referral Link',
                    }}
                  />
                </div>
              </div>
            </div>
          ) : (
            <div className={styles.affiliateLinkDescription}>
              As a benefit of your subscription, you can give 25% off access to The Information. You
              do not currently have access to this program as a non yearly subscriber, but if you
              would like to get access email{' '}
              <a className={styles.blueLink} href="mailto:support@theinformation.com">
                support@theinformation.com
              </a>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default Affiliate;
